export const replaceAmpersandInGCSUrls = (htmlString: string) => {
  const gcsUrlRegex = /https:\/\/storage\.googleapis\.com\/[^\s"]+/g;
  return htmlString.replace(gcsUrlRegex, (match) => {
    return match.replace(/&amp;/g, '&');
  });
};
